<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="icon-globe mr-2"></i>{{Core.Definition.getDefinition('Général')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormGeneral"
                        getRoot="/setting/booking-general"
                        saveRoot="/setting/booking-general"
                        :formStructure="dataFormStructures.general">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import Request from '../../../components/Request'
    import InputText from '../../../components/InputText'
    import InputNumber from '../../../components/InputNumber'
    export default {
        name: 'SettingsBooking',
        components: {
            DynamicForm,
            Request,
            InputText,
            InputNumber
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataTaxes: [],
                dataInvoicePreview: '',
                dataFormStructures: {
                    general: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Panneau des réservations'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'noticeIfUserHasProducts'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'noticeIfUserHasProductsIcon'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Fermeture'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'closeBooking'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Abonnement limité'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'evalBookingRemainingIfHasStatus'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'evalBookingRemainingIfChangeBefore'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }, {}
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'noticeIfUserHasProducts',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Mention si l\'utilisateur détient l\'un des produits'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'noticeIfUserHasProductsIcon',
                                type: 'text',
                                label: Core.Definition.getDefinition('Icône de la mention'),
                                value: 'icon-user-following'
                            },
                            {
                                id: 'closeBooking',
                                type: 'time',
                                label: Core.Definition.getDefinition('Fermeture des réservations'),
                                value: null,
                                description: Core.Definition.getDefinition('Indiquez le nombre d\'heures avant le début d\'un événement'),
                            },
                            {
                                id: 'evalBookingRemainingIfHasStatus',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Déduire le nombre de réservation de l\'abonnement si la réservation détient l\'un des états sélectionnés'),
                                value: null,
                                description: Core.Definition.getDefinition('La déduction sera remise si l\'état de la réservation est mise à jour et non présente dans les états sélectionnés.'),
                                onSelect: function() {}
                            },
                            {
                                id: 'evalBookingRemainingIfChangeBefore',
                                type: 'time',
                                label: Core.Definition.getDefinition('Temps limite avant l\'événement pour la remise de la réservation déduite.'),
                                description: Core.Definition.getDefinition('La déduction ne sera pas remise si l\'état de la réservation est mise à jour après le temps limite.'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
